import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const CreateNewRoom = (data) => {
  const url = {
    admin: urls.admin.messaging_rooms,
    customer: urls.messaging_room,
  };

  const requestOptions = {
    method: 'POST',
    url: url[data.role],
    params: {
      messaging_room: data.body, // for ex: { account_id: 1 }
    },
    paramsSerializer: params =>
      qs.stringify(params, { arrayFormat: 'brackets' }),
  };

  return axios(requestOptions).then(res => res.data);
};


export const GetMessagingRoom = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.messaging_room,
    params,
    paramsSerializer: params =>
      qs.stringify(params, { arrayFormat: 'brackets' }),
  };

  return axios(requestOptions).then(res => res.data);
};

export const GetRoomsList = params => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.messaging_rooms,
    params,
    paramsSerializer: params =>
      qs.stringify(params, { arrayFormat: 'brackets' }),
  };

  return axios(requestOptions).then(res => res.data);
};

export const CreateNewMessage = (data) => {
  const url = {
    admin: `${urls.admin.messaging_rooms}/${data.room_id}/messages`,
    customer: `${urls.messaging_room}/messages`,
  };

  const requestOptions = {
    method: 'POST',
    url: url[data.role],
    data: data.message,
  };

  return axios(requestOptions).then(res => res.data);
};

export const GetMessagesList = (data) => {
  const url = {
    admin: `${urls.admin.messaging_rooms}/${data.room_id}/messages`,
    customer: `${urls.messaging_room}/messages`,
  };

  const requestOptions = {
    method: 'GET',
    url: url[data.role],
    params: data.params, // for ex: {page: 1, limit: 10}
    paramsSerializer: params =>
      qs.stringify(params, { arrayFormat: 'brackets' }),
  };

  return axios(requestOptions).then(res => res.data);
};

export const DeleteMessage = (data) => {
  const url = {
    admin: `${urls.admin.messaging_rooms}/${data.room_id}/messages/${data.message_id}`,
    customer: `${urls.messaging_room}/messages/${data.message_id}`,
  };

  const requestOptions = {
    method: 'DELETE',
    url: url[data.role],
  };

  return axios(requestOptions).then(res => res.data);
};
